import {
  REDUX_CLEAR_NETWORK_ERROR,
  REDUX_SET_CONNECTIVITY_STATUS,
  REDUX_SET_NETWORK_ERROR,
} from '../Actions/Connectivity/ActionTypes/ReduxActionTypes'

export type ConnectivityReducer = {
  isOnline: boolean
  hasApiConnectivityIssue: boolean
  lastNetworkErrorMessage: string | null
}

// Default isOnline to true - navigator.onLine can briefly be false on page load/refresh
const initialState: ConnectivityReducer = {
  isOnline: true,
  hasApiConnectivityIssue: false,
  lastNetworkErrorMessage: null,
}

export default function connectivityReducer(
  state = initialState,
  action: {type: string; payload?: any}
): ConnectivityReducer {
  switch (action.type) {
    case REDUX_SET_CONNECTIVITY_STATUS:
      return {
        ...state,
        isOnline: action.payload?.isOnline ?? true,
        ...(action.payload?.isOnline
          ? {hasApiConnectivityIssue: false, lastNetworkErrorMessage: null}
          : {}),
      }
    case REDUX_SET_NETWORK_ERROR:
      return {
        ...state,
        hasApiConnectivityIssue: true,
        lastNetworkErrorMessage: action.payload?.message ?? null,
      }
    case REDUX_CLEAR_NETWORK_ERROR:
      return {
        ...state,
        hasApiConnectivityIssue: false,
        lastNetworkErrorMessage: null,
      }
    default:
      return state
  }
}
